<template>
  <section data-testid="small-experiences-section">
    <section>
      <HorizontalScrollWrapper scroll-button-box-style="h-[157px] md:h-[228px]">
        <template v-for="(experience, index) in experiences" :key="index + experience.slug">
          <ExperienceCard
            class="mb-2 w-[280px] shrink-0 overflow-hidden md:w-[360px] md:first:ml-0 md:last:mr-0"
            orientation="horizontal"
            theme="light"
            :data-testid="`experience-card-${index}`"
            :disable-carousel-on-sp="true"
            :experience="experience"
          />
        </template>
      </HorizontalScrollWrapper>
    </section>
  </section>
</template>

<script lang="ts" setup>
import { HorizontalScrollWrapper } from '@/wabunka-src/common/components';
import type { ExperienceListViewModel } from '@/wabunka-src/features/Experience';
import { ExperienceCard } from '@/wabunka-src/features/Experience';

interface Props {
  experiences: ExperienceListViewModel;
}

defineProps<Props>();
</script>
